import React from "react";
import ContentLoader from "react-content-loader";

export default props =>{
    return <ContentLoader
        speed={2}
        viewBox="0 0 400 1800"
        backgroundColor={'#eee'}
        foregroundColor={'#ccc'}
    >
        {/* 地址 */}
        <rect x="10" y="0" width="380" height="115" />

        {/* 包裹 */}
        <rect x="10" y="125" width="380" height="140" />

        {/* 邮费 */}
        <rect x="10" y="285" width="100" height="25" />
        <circle cx="24" cy="330" r="12"/>
        <rect x="38" y="320" width="200" height="25" />
        <rect x="38" y="355" width="250" height="25" />

        <circle cx="24" cy="400" r="12"/>
        <rect x="38" y="390" width="200" height="25" />
        <rect x="38" y="425" width="250" height="25" />

        {/* 支付方式 */}
        <rect x="10" y="470" width="380" height="47" />
        <rect x="10" y="518" width="380" height="47" />
        <rect x="10" y="566" width="380" height="47" />
        <rect x="10" y="614" width="380" height="47" />
        <rect x="10" y="662" width="380" height="47" />
        <rect x="10" y="710" width="380" height="47" />

        {/* coupon */}
        <rect x="10" y="767" width="380" height="42" />

        {/* order summary */}
        <rect x="10" y="819" width="380" height="190" />

    </ContentLoader>
}